import { Theme, Typography, Divider, Box } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { CustomTooltip } from 'app/components/Common/Tooltips';
import { selectMiscellaneousPlacementData } from 'store/redux-store/placement-details/selectors';
import { convertToFormat } from 'app/helpers/dateHelper';
import { LayoutGrid, LayoutGridItem } from 'app/layout/LayoutGrid';
import React from 'react';
import { useSelector } from 'react-redux';
import { getStateDesc } from '../LandsFormHelper';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles()((theme: Theme) => ({
  mainTitle: {
    textAlign: 'left',
    font: 'normal normal medium 14px/18px Roboto',
    letterSpacing: '0px',
    color: '#333333',
    opacity: 1,
    fontWeight: 500,
  },
  subTitle: {
    textAlign: 'left',
    font: 'normal normal medium 14px/18px Roboto',
    letterSpacing: '0px',
    color: '#333333',
    opacity: 1,
  },
  wrapper: {
    paddingTop: '0px',
    paddingLeft: '0px',
  },
  changeButton: {
    textAlign: 'right',
    fontWeight: 500,
    margin: 0,
    color: '#1898D7',
    cursor: 'pointer',
    fontSize: '14px',
    paddingRight: '35px !important',
    paddingTop: '20px !important',
  },
  showLess: {
    textAlign: 'left',
    font: 'normal normal medium 14px / 26px Roboto !important',
    fontWeight: 500,
    margin: 0,
    color: '#1898D7',
    cursor: 'pointer',
    fontSize: '14px',
    marginTop: '55px',
  },
  showMore: {
    textAlign: 'left',
    font: 'normal normal medium 14px / 26px Roboto !important',
    fontWeight: 500,
    color: '#1898D7',
    cursor: 'pointer',
    fontSize: '14px',
    marginTop: '10px',
  },
  sectionDivider: {
    margin: '12px 0px 12px 0px',
  },
  boxSec: {
    listStyleType: 'none',
    height: '10px',
  },
}));

export const LicenseDetailedView = props => {
  const { t } = useTranslation();
  const showMoreLbl = t(
    'placement.profile.tabs.LANDS/GTGTab.leftSideDetails.licenseWrapper.licenseDetailedView.showMore',
  );
  const { RequirementID, toggleSelection } = props;
  const { licensesList } = useSelector(selectMiscellaneousPlacementData);
  const [checked, setChecked] = React.useState(true);
  const [title, setTitle] = React.useState(showMoreLbl);
  const { classes } = useStyles();

  const BuildLabel = props => {
    const { mainTitle, subTitle } = props;
    return (
      <>
        <Box component="span">
          <ul className={classes.boxSec}>
            <li>
              <Typography component="div" className={classes.mainTitle}>
                {mainTitle}
              </Typography>
            </li>
            <li>
              <Typography component="div">{subTitle}</Typography>
            </li>
          </ul>
        </Box>
      </>
    );
  };

  const SingleLabel = props => {
    const { subTitle } = props;
    return (
      <>
        <Box component="span">
          <ul className={classes.boxSec}>
            <li>
              <Typography component="div" className={classes.subTitle}>
                {subTitle}
              </Typography>
            </li>
            <li>
              <Typography component="div">{''}</Typography>
            </li>
          </ul>
        </Box>
      </>
    );
  };

  const FirstRow = props => {
    const { item } = props;
    return (
      <>
        <LayoutGrid container direction="row">
          <LayoutGridItem item xs={2}>
            <BuildLabel
              mainTitle={
                item?.stateID
                  ? getStateDesc(item?.stateID)
                  : item?.licenseStateProvince
                  ? item?.licenseStateProvince
                  : '--'
              }
              subTitle={
                item?.licenseNumber
                  ? item?.licenseNumber
                  : !item?.lookups?.find(item => item.lookUpField === 'LicenseNumber')
                  ? 'N/A'
                  : '--'
              }
            />
          </LayoutGridItem>
          <LayoutGridItem item xs={3}>
            <BuildLabel
              mainTitle={
                item?.typeID === 192
                  ? t(
                      'placement.profile.tabs.LANDS/GTGTab.leftSideDetails.licenseWrapper.licenseDetailedView.permanent',
                    )
                  : t(
                      'placement.profile.tabs.LANDS/GTGTab.leftSideDetails.licenseWrapper.licenseDetailedView.temporary',
                    )
              }
              subTitle={
                item?.levelID === 307
                  ? t('placement.profile.tabs.LANDS/GTGTab.leftSideDetails.licenseWrapper.licenseDetailedView.compact')
                  : t(
                      'placement.profile.tabs.LANDS/GTGTab.leftSideDetails.licenseWrapper.licenseDetailedView.singleState',
                    )
              }
            />
          </LayoutGridItem>
          <LayoutGridItem item xs={5}>
            <BuildLabel
              mainTitle={item?.credentialName ? item?.credentialName : '--'}
              subTitle={`${
                item?.expirationDate
                  ? `${t(
                      'placement.profile.tabs.LANDS/GTGTab.leftSideDetails.licenseWrapper.licenseDetailedView.expires',
                    )} ` + convertToFormat(item?.expirationDate, 'MM/DD/YY')
                  : '--'
              }`}
            />
          </LayoutGridItem>
          <LayoutGridItem item xs={2} className={classes.changeButton} onClick={toggleSelection}>
            {t('placement.profile.tabs.LANDS/GTGTab.leftSideDetails.licenseWrapper.licenseDetailedView.change')}
          </LayoutGridItem>
        </LayoutGrid>
      </>
    );
  };

  const ClassicRow = props => {
    const { item } = props;
    return (
      <>
        <LayoutGrid container direction="row">
          <LayoutGridItem item xs={2}>
            <BuildLabel
              mainTitle={
                item?.stateID
                  ? getStateDesc(item?.stateID)
                  : item?.licenseStateProvince
                  ? item?.licenseStateProvince
                  : '--'
              }
              subTitle={
                item?.licenseNumber
                  ? item?.licenseNumber
                  : !item?.lookups?.find(item => item.lookUpField === 'LicenseNumber')
                  ? 'N/A'
                  : '--'
              }
            />
          </LayoutGridItem>
          <LayoutGridItem item xs={3}>
            <BuildLabel
              mainTitle={
                <LayoutGrid>
                  <LayoutGridItem>{'--'}</LayoutGridItem>
                  <LayoutGridItem>
                    <CustomTooltip
                      tooltipContent={t(
                        'placement.profile.tabs.LANDS/GTGTab.leftSideDetails.licenseWrapper.licenseDetailedView.licenseNameMissing',
                      )}
                    >
                      <InfoOutlinedIcon style={{ color: '#3CA0F5' }} />
                    </CustomTooltip>
                  </LayoutGridItem>
                </LayoutGrid>
              }
              subTitle={`${
                item?.expirationDate
                  ? `${t(
                      'placement.profile.tabs.LANDS/GTGTab.leftSideDetails.licenseWrapper.licenseDetailedView.expires',
                    )} ` + convertToFormat(item?.expirationDate, 'MM/DD/YY')
                  : '--'
              }`}
            />
          </LayoutGridItem>
          <LayoutGridItem item xs={5}>
            <BuildLabel
              mainTitle={
                item?.typeID === 192
                  ? t(
                      'placement.profile.tabs.LANDS/GTGTab.leftSideDetails.licenseWrapper.licenseDetailedView.permanent',
                    )
                  : t(
                      'placement.profile.tabs.LANDS/GTGTab.leftSideDetails.licenseWrapper.licenseDetailedView.temporary',
                    )
              }
              subTitle={
                item?.levelID === 307
                  ? t('placement.profile.tabs.LANDS/GTGTab.leftSideDetails.licenseWrapper.licenseDetailedView.compact')
                  : t(
                      'placement.profile.tabs.LANDS/GTGTab.leftSideDetails.licenseWrapper.licenseDetailedView.singleState',
                    )
              }
            />
          </LayoutGridItem>
          <LayoutGridItem item xs={2} className={classes.changeButton} onClick={toggleSelection}>
            {t('placement.profile.tabs.LANDS/GTGTab.leftSideDetails.licenseWrapper.licenseDetailedView.change')}
          </LayoutGridItem>
        </LayoutGrid>
      </>
    );
  };

  const SecondRow = props => {
    const { item } = props;
    return (
      <>
        <LayoutGrid container direction="row">
          <LayoutGridItem item xs={2}>
            <BuildLabel
              mainTitle={t(
                'placement.profile.tabs.LANDS/GTGTab.leftSideDetails.licenseWrapper.licenseDetailedView.paperless',
              )}
              subTitle={item?.paperlessID === 1 ? t('global.Yes') : t('global.No')}
            />
          </LayoutGridItem>
          <LayoutGridItem item xs={3}>
            {item?.paperlessDate ? (
              <BuildLabel
                mainTitle={`${t(
                  'placement.profile.tabs.LANDS/GTGTab.leftSideDetails.licenseWrapper.licenseDetailedView.paperless',
                )} ${item?.paperlessDate ? convertToFormat(item?.paperlessDate, 'MM/DD/YY') : '--'}`}
                subTitle={item?.paperlessByName?.first + ' ' + item?.paperlessByName?.last}
              />
            ) : (
              <SingleLabel
                subTitle={t(
                  'placement.profile.tabs.LANDS/GTGTab.leftSideDetails.licenseWrapper.licenseDetailedView.notPaperless',
                )}
              />
            )}
          </LayoutGridItem>
          <LayoutGridItem item xs={3}>
            <BuildLabel
              mainTitle={t(
                'placement.profile.tabs.LANDS/GTGTab.leftSideDetails.licenseWrapper.licenseDetailedView.dateCompleted',
              )}
              subTitle={item?.dateCompleted ? convertToFormat(item?.dateCompleted, 'MM/DD/YY') : '--'}
            />
          </LayoutGridItem>
          <LayoutGridItem item xs={3}>
            {item?.lastUpdate ? (
              <BuildLabel
                mainTitle={`${t(
                  'placement.profile.tabs.LANDS/GTGTab.leftSideDetails.licenseWrapper.licenseDetailedView.updated',
                )}  ${item?.lastUpdate ? convertToFormat(item?.lastUpdate, 'MM/DD/YY') : '--'}`}
                subTitle={item?.lastUpdatedByName?.first + ' ' + item?.lastUpdatedByName?.last}
              />
            ) : (
              <SingleLabel
                subTitle={t(
                  'placement.profile.tabs.LANDS/GTGTab.leftSideDetails.licenseWrapper.licenseDetailedView.notUpdated',
                )}
              />
            )}
          </LayoutGridItem>
        </LayoutGrid>
      </>
    );
  };

  const ThirdRow = props => {
    const { item } = props;
    return (
      <>
        <LayoutGrid container direction="row">
          <LayoutGridItem item xs={2}>
            {item?.contact ? (
              <BuildLabel
                mainTitle={t(
                  'placement.profile.tabs.LANDS/GTGTab.leftSideDetails.licenseWrapper.licenseDetailedView.contact',
                )}
                subTitle={item?.contact ? item?.contact : '--'}
              />
            ) : (
              <SingleLabel
                subTitle={t(
                  'placement.profile.tabs.LANDS/GTGTab.leftSideDetails.licenseWrapper.licenseDetailedView.noContact',
                )}
              />
            )}
          </LayoutGridItem>
          <LayoutGridItem item xs={3}>
            {item?.dateVerified ? (
              <BuildLabel
                mainTitle={`${t(
                  'placement.profile.tabs.LANDS/GTGTab.leftSideDetails.licenseWrapper.licenseDetailedView.verified',
                )}  ${item?.dateVerified ? convertToFormat(item?.dateVerified, 'MM/DD/YY') : '--'}`}
                subTitle={item?.verifiedByName?.first + ' ' + item?.verifiedByName?.last}
              />
            ) : (
              <SingleLabel
                subTitle={t(
                  'placement.profile.tabs.LANDS/GTGTab.leftSideDetails.licenseWrapper.licenseDetailedView.notVerified',
                )}
              />
            )}
          </LayoutGridItem>
          <LayoutGridItem item xs={3}>
            <BuildLabel
              mainTitle={t(
                'placement.profile.tabs.LANDS/GTGTab.leftSideDetails.licenseWrapper.licenseDetailedView.verified',
              )}
              subTitle={item?.verifiedID === 1 ? t('global.Yes') : t('global.No')}
            />
          </LayoutGridItem>
          <LayoutGridItem item xs={3}>
            {item?.disciplinaryActionID !== 2 ? (
              <BuildLabel
                mainTitle={t(
                  'placement.profile.tabs.LANDS/GTGTab.leftSideDetails.licenseWrapper.licenseDetailedView.disciplinaryAction',
                )}
                subTitle={item?.disciplinaryActionID === 1 ? t('global.Yes') : t('global.No')}
              />
            ) : (
              <></>
            )}
          </LayoutGridItem>
        </LayoutGrid>
      </>
    );
  };

  const FourthRow = props => {
    const { item } = props;
    return (
      <>
        <LayoutGrid container direction="row">
          <LayoutGridItem item xs={2}>
            <BuildLabel
              mainTitle={t(
                'placement.profile.tabs.LANDS/GTGTab.leftSideDetails.licenseWrapper.licenseDetailedView.onFile',
              )}
              subTitle={item?.onFileID === 1 ? t('global.Yes') : t('global.No')}
            />
          </LayoutGridItem>
          <LayoutGridItem item xs={10}>
            {item?.onFileDate ? (
              <BuildLabel
                mainTitle={`${t(
                  'placement.profile.tabs.LANDS/GTGTab.leftSideDetails.licenseWrapper.licenseDetailedView.onFile',
                )}  ${item?.onFileDate ? convertToFormat(item?.onFileDate, 'MM/DD/YY') : '--'}`}
                subTitle={item?.onFileBy?.first + ' ' + item?.onFileBy?.last}
              />
            ) : (
              <SingleLabel
                subTitle={t(
                  'placement.profile.tabs.LANDS/GTGTab.leftSideDetails.licenseWrapper.licenseDetailedView.notOnFile',
                )}
              />
            )}
          </LayoutGridItem>
        </LayoutGrid>
      </>
    );
  };

  const LastRow = props => {
    return (
      <>
        <LayoutGrid container direction="row">
          <LayoutGridItem item className={!checked ? classes.showLess : classes.showMore} onClick={handleCheck}>
            {title}
          </LayoutGridItem>
        </LayoutGrid>
      </>
    );
  };

  const handleCheck = () => {
    setChecked(!checked);
    setTitle(
      !checked
        ? t('placement.profile.tabs.LANDS/GTGTab.leftSideDetails.licenseWrapper.licenseDetailedView.showMore')
        : t('placement.profile.tabs.LANDS/GTGTab.leftSideDetails.licenseWrapper.licenseDetailedView.showLess'),
    );
  };

  return (
    <>
      {licensesList?.map((item, idx) => {
        if (item.requirementID === RequirementID) {
          return (
            <>
              {item.isClassicLicense ? (
                <LayoutGrid container direction="column" className={classes.wrapper}>
                  <LayoutGridItem item style={{ marginBottom: '10px', marginLeft: '-40px' }}>
                    <ClassicRow item={item} />
                  </LayoutGridItem>
                </LayoutGrid>
              ) : (
                <LayoutGrid container direction="column" className={classes.wrapper}>
                  <LayoutGridItem item style={{ marginBottom: '10px', marginLeft: '-40px' }}>
                    <FirstRow item={item} />
                  </LayoutGridItem>
                  {!checked ? (
                    <>
                      <LayoutGridItem item style={{ marginBottom: '10px', marginLeft: '-40px' }}>
                        <SecondRow item={item} />
                      </LayoutGridItem>
                      <LayoutGridItem item style={{ marginBottom: '15px', marginLeft: '-40px' }}>
                        <ThirdRow item={item} />
                      </LayoutGridItem>
                      <LayoutGridItem item style={{ marginBottom: '-30px', marginTop: '0px', marginLeft: '-40px' }}>
                        <FourthRow item={item} />
                      </LayoutGridItem>
                    </>
                  ) : (
                    <></>
                  )}
                  <LayoutGridItem item>
                    <LastRow />
                  </LayoutGridItem>
                </LayoutGrid>
              )}
            </>
          );
        }
      })}
      <Divider className={classes.sectionDivider} />
    </>
  );
};
